import { WhatsAppOutlined } from '@ant-design/icons'
import { useQuery } from '@apollo/client'
import { Button, Form } from 'antd'
import * as PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelectedBranch } from '../../../../context/branchContext'
import { useUser } from '../../../../context/userContext'
import { handleConfirmEmpty, renderMessageValues } from '../../../../shared/utils/messagesHelpers'
import SearchField from '../../../common/searchFields/SearchField'
import { StyledWhatsappButton } from './Calendar.styles'
import { SEARCH_MESSAGES_QUERY } from '@dentolize/clinic-mobile/src/shared/store/queries/appointmentQueries'
import { BRANCH_DETAILS } from '@dentolize/clinic-mobile/src/shared/store/queries/companyQueries'
import { getWhatsAppLink } from '../../../../shared/utils/helpers'

const WhatsAppButton = ({ patient, appointment, size, link, type = 'primary' }) => {
  const { user } = useUser()
  const [form] = Form.useForm()
  const { t } = useTranslation()
  const { selectedBranch } = useSelectedBranch()

  const { data: branchData } = useQuery(BRANCH_DETAILS, {
    variables: { branch: selectedBranch },
    skip: !selectedBranch,
    fetchPolicy: 'cache-first'
  })

  const { setFieldsValue } = form

  const handleSelectMessage = async ({ item }) => {
    const { body, empty } = renderMessageValues({
      val: item.details || '',
      user,
      branchData,
      t,
      patient,
      appointment,
      returnEmpty: true,
      link
    })
    const confirm = await handleConfirmEmpty(t, empty)

    if (confirm) {
      window.open(getWhatsAppLink(patient.phoneNumber, body), '_blank')
    }
    setFieldsValue({ message: null })
  }

  return patient.phoneNumber && user.permissions.phoneNumbers ? (
    <StyledWhatsappButton className={`flex-container${type === 'default' ? ' default' : ''}`} onClick={e => e.stopPropagation()}>
      <Button size={size} type={type}>
        <a
          href={getWhatsAppLink(patient.phoneNumber)}
          target="_blank"
          rel="noreferrer noopener"
          data-testid={`whatsapp-${link || 'main'}-button`}
        >
          <WhatsAppOutlined />
        </a>
      </Button>
      <Form form={form}>
        <SearchField
          GET_QUERY={SEARCH_MESSAGES_QUERY}
          fieldName="message"
          dataName="searchMessages"
          allowClear
          onSelect={handleSelectMessage}
          size={size}
          popupMatchSelectWidth={false}
          placeholder={t('app.search')}
        />
      </Form>
    </StyledWhatsappButton>
  ) : null
}

WhatsAppButton.propTypes = {
  patient: PropTypes.object.isRequired,
  appointment: PropTypes.object,
  link: PropTypes.string
}

export default WhatsAppButton
